/**
 * Dados ilustrativos da Validação Fiscal CBS/IBS.
 *
 * Esta tela é um esboço/demonstração do fluxo de conciliação entre a
 * Apuração Assistida (AA) da Receita Federal, o ERP do cliente e o DF-e
 * (XML), nos moldes do Decreto 12.955/2026. Não há integração real com a
 * AA ainda — todos os valores abaixo são fictícios, apenas para validar o
 * desenho da ferramenta (mesmo aviso presente no esboço original em HTML).
 */

// ========== CABEÇALHO / CONTEXTO ==========
export const contexto = {
  empresa: "Grupo Exemplo S.A.",
  cnpjRaiz: "00.000.000",
  competencia: "09/2026",
  prazoAA: "15/10/2026",
  prazoAjustes: "30/10/2026",
  diasRestantes: 23,
};

// ========== ABA 1: PAINEL DE FECHAMENTO ==========
export const etapasFechamento = [
  { ordem: 1, status: "concluida", label: "Fontes de dados" },
  { ordem: 2, status: "concluida", label: "Conciliação por chave" },
  { ordem: 3, status: "atual", label: "Tratar divergências" },
  { ordem: 4, status: "pendente", label: "RAD e saldo credor" },
  { ordem: 5, status: "pendente", label: "Aprovação por alçada" },
  { ordem: 6, status: "pendente", label: "Dossiê e confirmação" },
];

export const kpisPainel = [
  { label: "Documentos conciliados", valor: "94,2%", caption: "1.842 de 1.955 chaves" },
  { label: "Divergências abertas", valor: "37", caption: "8 críticas · 14 em D04" },
  { label: "Crédito travado (a apropriar)", valor: "R$ 48.310", caption: "9 fornecedores · decisão de RAD" },
  { label: "Saldo da AA (CBS)", valor: "R$ 126.480", caption: "a pagar · ainda não confirmado" },
];

export const empresasPainel = [
  { empresa: "Empresa Exemplo A", cnpjRaiz: "00.000.001", conciliacao: "98,1%", divergencias: 4, prazo: "30/10/2026", responsavel: "Analista 1", situacao: "ok" },
  { empresa: "Empresa Exemplo B", cnpjRaiz: "00.000.002", conciliacao: "93,0%", divergencias: 19, prazo: "30/10/2026", responsavel: "Analista 2", situacao: "atencao" },
  { empresa: "Empresa Exemplo C", cnpjRaiz: "00.000.003", conciliacao: "86,4%", divergencias: 14, prazo: "30/10/2026", responsavel: "Analista 1", situacao: "critico" },
];

export const SITUACAO_LABEL = {
  ok: "No prazo",
  atencao: "Atenção",
  critico: "Crítico",
};

// ========== ABA 2: DIVERGÊNCIAS ==========
export const resumoTipos = [
  { tipo: "D04", descricao: "crédito não apropriado", qtde: 14 },
  { tipo: "D03", descricao: "valor do débito", qtde: 9 },
  { tipo: "D01", descricao: "só na AA", qtde: 6 },
  { tipo: "D06", descricao: "evento sem referência", qtde: 5 },
  { tipo: "D11", descricao: "devolução fora da AA", qtde: 3 },
];

export const divergencias = [
  {
    id: "3526-8841",
    tipo: "D04",
    chave: "3526…8841",
    chaveCompleta: "3526 0900 0000 0000 0000 5500 1000 0088 4110 0008 8410",
    valor: "R$ 203,00",
    causa: "Fornecedor não extinguiu o débito",
    baseLegal: "Art. 47",
    acaoSugerida: "Cobrar ou avaliar RAD",
    responsavel: "Analista 1",
    gravidade: "media",
    tipoDocumento: "Compra",
    emissao: "12/09/2026",
    detalhe: {
      titulo: "Crédito esperado não apropriado",
      aa: { debitoFornecedor: "R$ 203,00", situacao: "não extinto", credito: "a apropriar", apropriado: "R$ 0,00" },
      erp: { cbsDestacada: "R$ 203,00", creditoEscriturado: "R$ 203,00", cst: "conforme nota", conta: "crédito de CBS" },
      xml: { vCbs: "R$ 203,00", autorizacao: "12/09/2026", eventos: "nenhum", itens: "3 · recálculo confere" },
      leitura:
        "A AA, o ERP e o XML concordam no valor. A diferença é de timing: o crédito só é apropriado quando o débito do fornecedor é extinto (art. 47). O ERP está com R$ 203,00 de crédito que a AA ainda não reconhece.",
      decisoes: [
        { id: "cobrar", label: "Cobrar o fornecedor e aguardar a extinção" },
        { id: "rad", label: "Recolher pelo adquirente (RAD) · art. 36", padrao: true },
        { id: "estornar", label: "Estornar no ERP até a apropriação" },
      ],
      justificativaPadrao:
        "Fornecedor recorrente com atraso; recolhimento pelo adquirente avaliado como melhor opção.",
      baseLegalTexto:
        "Decreto 12.955/2026, art. 47 (apropriação) · art. 36 (RAD vinculado à operação; excedente devolvido em até 3 dias úteis) · Resolução CGIBS 6/2026 para o IBS.",
      trilha: [
        "07/10 10:12 · Divergência criada pela conciliação",
        "07/10 10:31 · Analista 1 atribuiu a si",
        "07/10 10:44 · Decisão registrada: RAD (aguardando aprovação)",
      ],
      alcada: "Alçada: acima de R$ 5.000,00 exige aprovação do responsável técnico.",
    },
  },
  {
    id: "3526-1207",
    tipo: "D06",
    chave: "3526…1207",
    chaveCompleta: "3526 0900 0000 0000 0000 5500 1000 0012 0700 0001 2070",
    valor: "R$ 1.850,00",
    causa: "ND de pagamento antecipado sem referência",
    baseLegal: "ND/NC; Ato Conjunto 4/2026",
    acaoSugerida: "Vincular à nota de fornecimento",
    responsavel: "Analista 2",
    gravidade: "alta",
    tipoDocumento: "Nota de débito",
    emissao: "03/09/2026",
    detalhe: {
      titulo: "Evento sem referência à nota de fornecimento",
      aa: { debitoFornecedor: "R$ 1.850,00", situacao: "pendente de vínculo", credito: "indefinido", apropriado: "R$ 0,00" },
      erp: { cbsDestacada: "R$ 1.850,00", creditoEscriturado: "R$ 0,00", cst: "não classificado", conta: "adiantamento a fornecedor" },
      xml: { vCbs: "—", autorizacao: "—", eventos: "ND sem NF-e vinculada", itens: "—" },
      leitura:
        "A ND de pagamento antecipado não traz a chave da nota de fornecimento original. Sem o vínculo, a AA não consegue casar débito e crédito.",
      decisoes: [
        { id: "vincular", label: "Buscar a nota de fornecimento e vincular manualmente", padrao: true },
        { id: "contatar", label: "Contatar o fornecedor para reemissão com referência" },
        { id: "provisionar", label: "Manter provisionado até a próxima competência" },
      ],
      justificativaPadrao: "ND recorrente deste fornecedor; vínculo manual já identificado no ERP.",
      baseLegalTexto: "ND/NC conforme Ato Conjunto RFB/CGIBS 4/2026 — vinculação obrigatória à operação de origem.",
      trilha: [
        "07/10 09:02 · Divergência criada pela conciliação",
        "07/10 09:40 · Analista 2 atribuiu a si",
      ],
      alcada: "Alçada: acima de R$ 5.000,00 exige aprovação do responsável técnico.",
    },
  },
  {
    id: "3526-5530",
    tipo: "D03",
    chave: "3526…5530",
    chaveCompleta: "3526 0900 0000 0000 0000 5500 1000 0055 3000 0005 5300",
    valor: "R$ 0,07",
    causa: "Arredondamento no item",
    baseLegal: "Calculadora de Tributos",
    acaoSugerida: "Aceitar dentro da tolerância",
    responsavel: "Analista 1",
    gravidade: "baixa",
    tipoDocumento: "Compra",
    emissao: "14/09/2026",
    detalhe: {
      titulo: "Diferença de arredondamento no item",
      aa: { debitoFornecedor: "R$ 203,07", situacao: "extinto", credito: "apropriado", apropriado: "R$ 203,07" },
      erp: { cbsDestacada: "R$ 203,00", creditoEscriturado: "R$ 203,00", cst: "conforme nota", conta: "crédito de CBS" },
      xml: { vCbs: "R$ 203,07", autorizacao: "14/09/2026", eventos: "nenhum", itens: "1 · arredondamento no cálculo por item" },
      leitura:
        "Diferença de R$ 0,07 decorrente do arredondamento no cálculo item a item pela Calculadora de Tributos. Está dentro da tolerância configurada para o cliente.",
      decisoes: [
        { id: "aceitar", label: "Aceitar dentro da tolerância (sem ajuste)", padrao: true },
        { id: "ajustar", label: "Ajustar manualmente o valor no ERP" },
      ],
      justificativaPadrao: "Diferença de centavos por arredondamento, dentro da tolerância parametrizada.",
      baseLegalTexto: "Cálculo pela Calculadora de Tributos (IBS/CBS) — tolerância de arredondamento por parâmetro do cliente.",
      trilha: ["07/10 08:15 · Divergência criada pela conciliação"],
      alcada: "Dentro da alçada do analista — não exige aprovação.",
    },
  },
  {
    id: "3526-9014",
    tipo: "D01",
    chave: "3526…9014",
    chaveCompleta: "3526 0900 0000 0000 0000 5500 1000 0090 1400 0009 0140",
    valor: "R$ 12.400,00",
    causa: "Documento na AA sem registro no ERP",
    baseLegal: "Art. 44",
    acaoSugerida: "Buscar o XML e lançar, ou ajustar",
    responsavel: "Analista 2",
    gravidade: "alta",
    tipoDocumento: "Venda",
    emissao: "20/09/2026",
    detalhe: {
      titulo: "Documento presente na AA sem registro correspondente no ERP",
      aa: { debitoFornecedor: "R$ 12.400,00", situacao: "extinto", credito: "não aplicável (débito próprio)", apropriado: "—" },
      erp: { cbsDestacada: "não localizado", creditoEscriturado: "—", cst: "—", conta: "—" },
      xml: { vCbs: "R$ 12.400,00", autorizacao: "20/09/2026", eventos: "nenhum", itens: "5 · documento autorizado e válido" },
      leitura:
        "A AA e o DF-e confirmam a operação, mas não há lançamento equivalente no ERP. Provável falha de integração ou lançamento manual perdido.",
      decisoes: [
        { id: "lancar", label: "Buscar o XML e lançar no ERP", padrao: true },
        { id: "ajustarAA", label: "Solicitar ajuste na AA (documento cancelado/duplicado)" },
      ],
      justificativaPadrao: "Falha pontual de integração identificada; XML localizado e será lançado no ERP.",
      baseLegalTexto: "Decreto 12.955/2026, art. 44 — documento fiscal válido gera débito/crédito na AA independentemente do ERP.",
      trilha: [
        "07/10 11:00 · Divergência criada pela conciliação",
        "07/10 11:20 · Analista 2 atribuiu a si",
      ],
      alcada: "Alçada: acima de R$ 5.000,00 exige aprovação do responsável técnico.",
    },
  },
  {
    id: "3526-2276",
    tipo: "D11",
    chave: "3526…2276",
    chaveCompleta: "3526 0900 0000 0000 0000 5500 1000 0022 7600 0002 2760",
    valor: "R$ 980,00",
    causa: "Devolução que a AA ainda não trata",
    baseLegal: "Art. 57",
    acaoSugerida: "Controle paralelo e registro",
    responsavel: "Analista 1",
    gravidade: "media",
    tipoDocumento: "Devolução",
    emissao: "25/09/2026",
    detalhe: {
      titulo: "Devolução de mercadoria fora do escopo atual da AA",
      aa: { debitoFornecedor: "não considerado", situacao: "fora do escopo", credito: "não aplicável", apropriado: "—" },
      erp: { cbsDestacada: "R$ 980,00 (estorno)", creditoEscriturado: "estorno registrado", cst: "conforme NF-e de devolução", conta: "estorno de débito de CBS" },
      xml: { vCbs: "R$ 980,00", autorizacao: "25/09/2026", eventos: "devolução vinculada à NF-e original", itens: "2" },
      leitura:
        "A devolução está corretamente registrada no ERP e no XML, mas a AA ainda não processa esse tipo de evento automaticamente — controle paralelo é necessário até a RFB ajustar o processamento.",
      decisoes: [
        { id: "paralelo", label: "Manter controle paralelo e registrar para o dossiê", padrao: true },
        { id: "reclassificar", label: "Reclassificar como divergência de menor prioridade" },
      ],
      justificativaPadrao: "Limitação conhecida da AA para devoluções; controle paralelo mantido e documentado.",
      baseLegalTexto: "Decreto 12.955/2026, art. 57 — tratamento de devoluções na apuração assistida.",
      trilha: ["07/10 13:05 · Divergência criada pela conciliação"],
      alcada: "Dentro da alçada do analista — não exige aprovação.",
    },
  },
  {
    id: "3526-6603",
    tipo: "D04",
    chave: "3526…6603",
    chaveCompleta: "3526 0900 0000 0000 0000 5500 1000 0066 0300 0006 6030",
    valor: "R$ 5.120,00",
    causa: "Crédito travado de fornecedor recorrente",
    baseLegal: "Art. 47; art. 36",
    acaoSugerida: "Decidir RAD (tela de crédito)",
    responsavel: "Analista 2",
    gravidade: "alta",
    tipoDocumento: "Compra",
    emissao: "18/09/2026",
    detalhe: {
      titulo: "Crédito travado — fornecedor recorrente (Fornecedor 04)",
      aa: { debitoFornecedor: "R$ 5.120,00", situacao: "não extinto", credito: "a apropriar", apropriado: "R$ 0,00" },
      erp: { cbsDestacada: "R$ 5.120,00", creditoEscriturado: "R$ 5.120,00", cst: "conforme nota", conta: "crédito de CBS" },
      xml: { vCbs: "R$ 5.120,00", autorizacao: "18/09/2026", eventos: "nenhum", itens: "6 · recálculo confere" },
      leitura:
        "Fornecedor 04 acumula 3 meses seguidos de crédito travado. Já existe decisão de RAD registrada na aba Crédito Travado para este fornecedor.",
      decisoes: [
        { id: "rad", label: "Recolher pelo adquirente (RAD) · art. 36", padrao: true },
        { id: "cobrar", label: "Cobrar o fornecedor e aguardar a extinção" },
      ],
      justificativaPadrao: "RAD já decidido para este fornecedor nesta competência — ver aba Crédito Travado.",
      baseLegalTexto: "Decreto 12.955/2026, art. 47 (apropriação) · art. 36 (RAD).",
      trilha: [
        "06/10 15:30 · Divergência criada pela conciliação",
        "07/10 09:10 · RAD decidido para o Fornecedor 04 (ver Crédito Travado)",
      ],
      alcada: "Alçada: acima de R$ 5.000,00 exige aprovação do responsável técnico.",
    },
  },
];

// ========== ABA 4: CRÉDITO TRAVADO ==========
export const kpisCredito = [
  { label: "Total travado", valor: "R$ 48.310" },
  { label: "Fornecedores", valor: "9" },
  { label: "RAD já decidido nesta competência", valor: "R$ 5.120" },
];

export const fornecedoresCredito = [
  { fornecedor: "Fornecedor 01", cnpj: "00.000.101/0001-00", documentos: 41, credito: "R$ 18.900,00", recorrencia: "4 meses seguidos", sugestao: "rad" },
  { fornecedor: "Fornecedor 02", cnpj: "00.000.102/0001-00", documentos: 23, credito: "R$ 11.250,00", recorrencia: "2 meses", sugestao: "rad" },
  { fornecedor: "Fornecedor 03", cnpj: "00.000.103/0001-00", documentos: 12, credito: "R$ 7.100,00", recorrencia: "1º mês", sugestao: "cobrar" },
  { fornecedor: "Fornecedor 04", cnpj: "00.000.104/0001-00", documentos: 6, credito: "R$ 5.120,00", recorrencia: "3 meses", sugestao: "rad-decidido" },
  { fornecedor: "Fornecedor 05", cnpj: "00.000.105/0001-00", documentos: 9, credito: "R$ 3.040,00", recorrencia: "1º mês", sugestao: "cobrar" },
  { fornecedor: "Outros 4 fornecedores", cnpj: null, documentos: 14, credito: "R$ 2.900,00", recorrencia: "—", sugestao: null },
];

export const simulacaoRadPadrao = {
  fornecedor: "Fornecedor 01",
  documentosSelecionados: 41,
  valorARecolher: 18900,
  creditoAposRecolhimento: 18900,
  efeitoSaldoAA: -18900,
};

// ========== ABA 5: LIQUIDAÇÃO PLANEJADA ==========
export const kpisLiquidacao = [
  { label: "Créditos disponíveis (apropriados)", valor: "R$ 64.800", caption: "podem ser usados · art. 53" },
  { label: "Créditos a apropriar", valor: "R$ 48.310", caption: "débito do fornecedor ainda não extinto · art. 47" },
  { label: "Vencem em até 12 meses", valor: "R$ 2.140", caption: "prazo de 5 anos · art. 54" },
  { label: "Exposição ao split", valor: "R$ 26.550", caption: "3 de 5 operações do exemplo" },
];

export const projecaoLiquidacao = [
  { chave: "3526…1101", autorizacao: "07/10 08:02", debito: 18400, creditoImputado: 18400, saldoAberto: 0 },
  { chave: "3526…1102", autorizacao: "07/10 09:15", debito: 22150, creditoImputado: 22150, saldoAberto: 0 },
  { chave: "3526…1103", autorizacao: "07/10 11:40", debito: 31900, creditoImputado: 24250, saldoAberto: 7650 },
  { chave: "3526…1104", autorizacao: "07/10 14:05", debito: 12300, creditoImputado: 0, saldoAberto: 12300 },
  { chave: "3526…1105", autorizacao: "07/10 16:30", debito: 6600, creditoImputado: 0, saldoAberto: 6600 },
];

export const totaisProjecao = { debito: 91350, creditoImputado: 64800, saldoAberto: 26550 };

export const cenariosLiquidacao = [
  {
    id: "A",
    titulo: "A · Deixar o split ocorrer",
    descricao:
      "Os 3 documentos com saldo aberto têm CBS segregada na liquidação financeira, sobre a diferença ainda não extinta (art. 29, § 4º).",
    retido: "R$ 26.550,00",
  },
  {
    id: "B",
    titulo: "B · Pagar o saldo antes",
    descricao:
      "Pagamento pelo contribuinte, imputado na mesma ordem cronológica. Evita a segregação nas operações cobertas. Exige caixa antecipado.",
    retido: "R$ 0,00",
    referencia: true,
  },
  {
    id: "C",
    titulo: "C · Aguardar novos créditos",
    descricao:
      "Espera a apropriação de créditos hoje travados (R$ 48.310) e reavalia. O split pode ocorrer antes disso.",
    retido: "Depende da liquidação",
  },
];

// ========== ABA 6: DOSSIÊ ==========
export const dossie = {
  resumoSaldo: [
    { componente: "Débitos do período", valor: "412.900,00", base: "Art. 44" },
    { componente: "(−) Créditos apropriados", valor: "270.420,00", base: "Art. 47" },
    { componente: "(−) Saldo a recuperar anterior", valor: "16.000,00", base: "Art. 53, I e II" },
    { componente: "Saldo a pagar (AA)", valor: "126.480,00", base: "Conferido com a AA", destaque: true },
  ],
  conciliacao: [
    { label: "Chaves analisadas", valor: "1.955" },
    { label: "Conciliadas", valor: "1.842" },
    { label: "Com divergência", valor: "113" },
    { label: "Fora do escopo da AA", valor: "0" },
  ],
  divergenciasTratamento: [
    { tipo: "D04 crédito não apropriado", qtde: 14, tratamento: "5 com RAD decidido; 9 em cobrança", baseLegal: "Arts. 36 e 47" },
    { tipo: "D03 valor do débito", qtde: 9, tratamento: "Dentro da tolerância ou recalculado", baseLegal: "Calculadora de Tributos" },
    { tipo: "D01 só na AA, sem registro no ERP", qtde: 6, tratamento: "XML localizado e lançado, ou ajuste na AA", baseLegal: "Art. 44" },
    { tipo: "D06 evento sem referência", qtde: 5, tratamento: "Vinculados à nota de fornecimento", baseLegal: "ND/NC" },
    { tipo: "D11 devolução fora da AA", qtde: 3, tratamento: "Controle paralelo registrado", baseLegal: "Art. 57" },
  ],
  decisoesPeriodo: [
    "RAD: R$ 5.120,00 recolhidos pelo adquirente, vinculados às operações indicadas.",
    "Saldo credor: sem saldo credor nesta competência.",
    "Ajustes na AA: [quantidade] ajustes, cada um com justificativa e evidência anexa.",
  ],
};
